import {
  CHANGE_ORDERS_LOAD_SUCCESS,
  CHANGE_ORDERS_ADD,
  CHANGE_ORDER_MODAL_CLOSE,
  CHANGE_ORDER_MODAL_SHOW,
  CHANGE_ORDER_START_DATE_UPDATE,
  CHANGE_ORDER_COMPLETION_DATE_UPDATE,
  CHANGE_ORDER_VALUES_UPDATE,
  CHANGE_ORDER_BACK,
  CHANGE_ORDER_CREATE_SUCCESS,
  CHANGE_ORDER_NEXT,
  CHANGE_ORDER_APPROVAL_MODAL_CLOSE,
  CHANGE_ORDER_APPROVAL_SELECT,
  CHANGE_ORDERS_UPDATE,
  CHANGE_ORDER_SUCCESS_MODAL_OPEN,
  CHANGE_ORDER_SUCCESS_MODAL_CLOSE,
  CHANGE_ORDER_PRINT_SUCCESS,
  CHANGE_ORDER_PDF_VIEWER_CLOSE,
  CHANGE_ORDER_EMAIL_MODAL_SHOW_SET,
  CHANGE_ORDER_USERS_LOAD_SUCCESS,
  CHANGE_ORDER_SUBJECT_SET,
  CHANGE_ORDER_MESSAGE_SET,
  CHANGE_ORDER_EMAIL_ADD,
  CHANGE_ORDER_EMAIL_CLEAR,
  CHANGE_ORDER_EMAIL_REMOVE,
} from 'components/admin/work-orders/details/change-orders/store/action-types';
import { showErrorMessage } from 'actions/messages';
import { changeOrdersApi } from 'services/api/change-orders-api';
import {
  calculateFee,
  calculateInsurace,
  calculateMarkup,
} from 'services/utils/proposal-util';
import { getFirstDate, getLastDate } from 'services/utils/date-util';
import { detailsAddChangeOrder } from 'actions/admin/work-orders/details/details';
import { ROLES, usersUtil } from 'services/utils/users-util';
import { clientsApi } from 'services/api/clients-api';
import numeral from 'numeral';

export function loadChangeOrdersRequest(workOrderId) {
  return (dispatch) => {
    return changeOrdersApi.getChangeOrders(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(loadChangeOrdersSuccess(response.changeOrders));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadChangeOrdersSuccess(changeOrders) {
  return {
    type: CHANGE_ORDERS_LOAD_SUCCESS,
    payload: changeOrders,
  };
}

export function closeChangeOrderModal() {
  return {
    type: CHANGE_ORDER_MODAL_CLOSE,
  };
}

export function setShowChangeOrderModal() {
  return {
    type: CHANGE_ORDER_MODAL_SHOW,
  };
}

export function showChangeOrderModal(quotesSelectedByTaskId, changeOrderTasks) {
  return (dispatch) => {
    const startDates = [];
    const completionDates = [];
    Object.values(quotesSelectedByTaskId).forEach((changeOrderTaskId) => {
      const changeOrderTask = changeOrderTasks.find(
        (cot) => cot.id === changeOrderTaskId
      );
      const changeOrderQuote = changeOrderTask.change_order_quote;
      const changeOrderQuoteTotal =
        numeral(changeOrderQuote.estimate).value() +
        numeral(changeOrderQuote.value).value();
      const markup = Math.round(calculateMarkup(changeOrderQuoteTotal));
      const fee = Math.round(calculateFee(changeOrderQuoteTotal));
      const insurance = Math.round(calculateInsurace(changeOrderQuoteTotal));
      dispatch(updateCOValue(changeOrderTaskId, 'markup', markup));
      dispatch(updateCOValue(changeOrderTaskId, 'fee', fee));
      dispatch(updateCOValue(changeOrderTaskId, 'insurance', insurance));
      startDates.push(changeOrderQuote.start_date);
      completionDates.push(changeOrderQuote.end_date);
    });

    dispatch(updateCOStartDate(getFirstDate(startDates)));
    dispatch(updateCOCompletionDate(getLastDate(completionDates)));
    dispatch(setShowChangeOrderModal());
  };
}

export function addChangeOrder(changeOrder) {
  return {
    type: CHANGE_ORDERS_ADD,
    payload: changeOrder,
  };
}

export function updateChangeOrder(changeOrder) {
  return {
    type: CHANGE_ORDERS_UPDATE,
    payload: changeOrder,
  };
}

export function updateCOStartDate(value) {
  return {
    type: CHANGE_ORDER_START_DATE_UPDATE,
    payload: value,
  };
}

export function updateCOCompletionDate(value) {
  return {
    type: CHANGE_ORDER_COMPLETION_DATE_UPDATE,
    payload: value,
  };
}

export function updateCOValue(quoteId, valueKey, value) {
  return {
    type: CHANGE_ORDER_VALUES_UPDATE,
    payload: { quoteId, key: valueKey, value: value },
  };
}

export function back(view) {
  const previousActions = {
    review: 'form',
  };
  return {
    type: CHANGE_ORDER_BACK,
    payload: previousActions[view],
  };
}

export function continueRequest(
  currentWorkOrderId,
  startDate,
  completionDate,
  valuesByQuoteId,
  qualifications,
  selectedQualificationsById
) {
  return (dispatch) => {
    const addedValues = Object.entries(valuesByQuoteId).map((element) => {
      const values = element[1];
      return {
        change_order_task_id: element[0],
        fee: values['fee'],
        insurance: values['insurance'],
        markup: values['markup'],
      };
    });

    const selectedQualifications = qualifications
      .filter((q) => selectedQualificationsById[q.id])
      .map((q) => {
        const value = selectedQualificationsById[q.id];
        return {
          qualification_id: value.id,
          option: value.option !== null ? value.option.label : null,
        };
      });

    return changeOrdersApi
      .createChangeOrder(
        currentWorkOrderId,
        startDate,
        completionDate,
        addedValues,
        selectedQualifications
      )
      .then((response) => {
        if (response.ok) {
          dispatch(continueSuccess());
          dispatch(addChangeOrder(response.changeOrder));
          dispatch(detailsAddChangeOrder());
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function continueSuccess() {
  return {
    type: CHANGE_ORDER_CREATE_SUCCESS,
  };
}

export function next(view) {
  const nextActions = {
    form: 'review',
    review: 'thank-you',
  };
  return {
    type: CHANGE_ORDER_NEXT,
    payload: nextActions[view],
  };
}

export function closeChangeOrderApprovalModal() {
  return {
    type: CHANGE_ORDER_APPROVAL_MODAL_CLOSE,
  };
}

export function selectChangeOrder(changeOrder) {
  return {
    type: CHANGE_ORDER_APPROVAL_SELECT,
    payload: changeOrder,
  };
}

export function openSuccessModal() {
  return {
    type: CHANGE_ORDER_SUCCESS_MODAL_OPEN,
  };
}

export function closeSuccessModal() {
  return {
    type: CHANGE_ORDER_SUCCESS_MODAL_CLOSE,
  };
}

export function approveChangeOrderRequest(selectedChangeOrderId) {
  return (dispatch) => {
    return changeOrdersApi
      .approveChangeOrder(selectedChangeOrderId)
      .then((response) => {
        if (response.ok) {
          dispatch(updateChangeOrder(response.changeOrder));
          dispatch(openSuccessModal());
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function printChangeOrder(changeOrderId) {
  return (dispatch) => {
    return changeOrdersApi.getAsPdf(changeOrderId).then((response) => {
      if (response.ok) {
        dispatch(printChangeOrderSuccess(response.pdf));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function printChangeOrderSuccess(pdf) {
  return {
    type: CHANGE_ORDER_PRINT_SUCCESS,
    payload: pdf,
  };
}

export function closePdfViewer() {
  return {
    type: CHANGE_ORDER_PDF_VIEWER_CLOSE,
  };
}

export function setShowEmailModal(value) {
  return {
    type: CHANGE_ORDER_EMAIL_MODAL_SHOW_SET,
    payload: value,
  };
}

export function loadEmailChangeOrderDataRequest(
  changeOrderNumber,
  workOrderNumber,
  workOrderName,
  buildingLocation,
  clientId
) {
  return (dispatch) => {
    return clientsApi.getUsers(clientId).then((response) => {
      if (response.ok) {
        dispatch(loadUsersSuccess(response.users));
        dispatch(
          initializeEmailValues(
            changeOrderNumber,
            workOrderNumber,
            workOrderName,
            buildingLocation,
            response.users
          )
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadUsersSuccess(users) {
  return {
    type: CHANGE_ORDER_USERS_LOAD_SUCCESS,
    payload: users,
  };
}

export function initializeEmailValues(
  changeOrderNumber,
  workOrderNumber,
  workOrderName,
  buildingLocation,
  users
) {
  return (dispatch) => {
    // Create and dispatch generated subject and message
    dispatch(
      setChangeOrderSubject(
        createChangeOrderSubject(workOrderNumber, workOrderName)
      )
    );
    dispatch(
      setChangeOrderMessage(
        createChangeOrderMessage(
          changeOrderNumber,
          workOrderNumber,
          buildingLocation
        )
      )
    );

    // Clear emails
    dispatch(clearEmails());
    // Add client owner by default
    const owner = users.find((user) => usersUtil.hasRole(user, ROLES.OWNER));
    if (owner !== undefined) {
      dispatch(addEmail(owner.email));
    }
  };
}

export function setChangeOrderSubject(subject) {
  return {
    type: CHANGE_ORDER_SUBJECT_SET,
    payload: subject,
  };
}

export function setChangeOrderMessage(message) {
  return {
    type: CHANGE_ORDER_MESSAGE_SET,
    payload: message,
  };
}

export function createChangeOrderSubject(
  workOrderNumber,
  workOrderName = null
) {
  const prefix = `Spackle Change Order for WO #${workOrderNumber}`;
  if (workOrderName !== null && workOrderName !== '') {
    return `${prefix} - ${workOrderName}`;
  } else {
    return prefix;
  }
}

export function createChangeOrderMessage(
  changeOrderNumber,
  workOrderNumber,
  buildingLocation = null
) {
  let location = '';
  if (buildingLocation !== null) {
    location = ` at ${buildingLocation.street_address_1}, ${buildingLocation.city} ${buildingLocation.state}`;
  }

  return `Please find the attached change order #${changeOrderNumber} for WO #${workOrderNumber}${location}. If you have any questions, please reach out via chat or email.

Thank you`;
}

export function addEmail(email) {
  return {
    type: CHANGE_ORDER_EMAIL_ADD,
    payload: email,
  };
}

export function clearEmails() {
  return {
    type: CHANGE_ORDER_EMAIL_CLEAR,
  };
}

export function removeEmail(email) {
  return {
    type: CHANGE_ORDER_EMAIL_REMOVE,
    payload: email,
  };
}

export function sendEmail(changeOrderId, emails, subject, message) {
  return (dispatch) => {
    return changeOrdersApi
      .sendEmail(changeOrderId, emails, subject, message)
      .then((response) => {
        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function withdrawChangeOrderRequest(changeOrderId) {
  return (dispatch) => {
    return changeOrdersApi
      .withdrawChangeOrder(changeOrderId)
      .then((response) => {
        if (response.ok) {
          dispatch(updateChangeOrder(response.changeOrder));
          dispatch(closeChangeOrderApprovalModal());
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-orders/store/actions.js